import { Component } from '@angular/core';

@Component({
	selector: 'seira-dados-meteorologicos',
	templateUrl: './dados-meteorologicos.component.html',
	styleUrls: ['./dados-meteorologicos.component.scss'],
})
export class DadosMeteorologicosComponent {}
